
/**
 * 
 */
export enum TipoCanalArchivo {
  WEB = 1,
  PRESENCIAL = 2,
  TRIBUNAL = 3,
  ARCHIVO_CENTRAL = 4,
  CENTRO_DIGITALIZACION = 5,
}

export enum GrupoCanalArchivo {
  /** Documentos cargados por la parte */
  PARTE = 1,
  /** Documentos generados por el tribunal */
  TRIBUNAL = 2
}

export enum TipoAccionRegistroActividad {
  DESCARGAR = 11,
  VISUALIZAR = 12,
}